import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'orderBy',
})
export class OrderByPipe implements PipeTransform {
    // Overload signatures for proper type inference
    public transform<T>(value: T[], expression?: string, reverse?: boolean): T[];
    public transform<T>(value: T, expression?: string, reverse?: boolean): T;
    public transform<T>(value: null | undefined, expression?: string, reverse?: boolean): null | undefined;
    public transform<T>(
        value: T | T[] | null | undefined,
        expression?: string,
        reverse?: boolean
    ): T | T[] | null | undefined {
        if (!value) {
            return value;
        }

        if (Array.isArray(value)) {
            return this.sortArray(value, expression, reverse);
        }

        return value;
    }

    /**
     * Sort array
     *
     * @param value
     * @param expression
     * @param reverse
     * @returns {T[]}
     */
    private sortArray<T>(
        value: T[],
        expression?: string,
        reverse?: boolean
    ): T[] {
        const array = [...value].sort((a: T, b: T): number => {
            if (!expression) {
                return a > b ? 1 : -1;
            }
            const aVal = (a as Record<string, unknown>)[expression];
            const bVal = (b as Record<string, unknown>)[expression];
            if (typeof aVal === 'string' && typeof bVal === 'string') {
                return aVal.toUpperCase() > bVal.toUpperCase() ? 1 : -1;
            } else {
                return (aVal as unknown) > (bVal as unknown) ? 1 : -1;
            }
        });

        if (reverse) {
            return array.reverse();
        }

        return array;
    }
}
